// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	AddressSelectField,
	CountrySelectField,
	EmailAddressSelectField,
	EmployeeSelectField,
	GuardianSelectField,
	LanguageSelectField,
	MediaAttachmentSelectField,
	PhoneNumberSelectField,
	StudentSelectField,
	UserSelectField,
} from "../../Forms";
import { PersonFormValues } from "../../FormUtilities";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "givenName" },
		{ value: "middleName" },
		{ value: "familyName" },
		{ value: "nameOrder" },
		{ value: "nickname" },
		{ value: "alternateNames" },
		{ value: "publicNameFormat" },
		{ value: "gender" },
		{ value: "dateOfBirth" },
		{ value: "englishLanguageFluency" },
		{ value: "occupation" },
		{ value: "nationalIdentificationNumber" },
		{ value: "governmentDocumentSeries" },
		{ value: "governmentDocumentNumber" },
		{ value: "governmentDocumentIssuedBy" },
		{ value: "addresses" },
		{ value: "emailAddresses" },
		{ value: "employee" },
		{ value: "guardian" },
		{ value: "languages" },
		{ value: "nationalities" },
		{ value: "phoneNumbers" },
		{ value: "student" },
		{ value: "taggedMediaAttachments" },
		{ value: "user" },
	],
	fieldComparisonOptions: {
		givenName: IndexForms.stringComparisonOptions,
		middleName: IndexForms.stringComparisonOptions,
		familyName: IndexForms.stringComparisonOptions,
		nameOrder: IndexForms.enumComparisonOptions,
		nickname: IndexForms.stringComparisonOptions,
		alternateNames: IndexForms.stringComparisonOptions,
		publicNameFormat: IndexForms.enumComparisonOptions,
		gender: IndexForms.stringComparisonOptions,
		dateOfBirth: [...IndexForms.dateComparisonOptions, ...IndexForms.nullableComparisonOptions],
		englishLanguageFluency: [...IndexForms.enumComparisonOptions, ...IndexForms.nullableComparisonOptions],
		occupation: IndexForms.stringComparisonOptions,
		nationalIdentificationNumber: IndexForms.stringComparisonOptions,
		governmentDocumentSeries: IndexForms.stringComparisonOptions,
		governmentDocumentNumber: IndexForms.stringComparisonOptions,
		governmentDocumentIssuedBy: IndexForms.stringComparisonOptions,
		addresses: IndexForms.multipleEdgeComparisonOptions,
		emailAddresses: IndexForms.multipleEdgeComparisonOptions,
		employee: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		guardian: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		languages: IndexForms.multipleEdgeComparisonOptions,
		nationalities: IndexForms.multipleEdgeComparisonOptions,
		phoneNumbers: IndexForms.multipleEdgeComparisonOptions,
		student: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		taggedMediaAttachments: IndexForms.multipleEdgeComparisonOptions,
		user: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
	},
	fieldComparisonTranslations: {
		givenName: IndexForms.stringComparisonTranslations,
		middleName: IndexForms.stringComparisonTranslations,
		familyName: IndexForms.stringComparisonTranslations,
		nameOrder: IndexForms.getRadioComparisonTranslations(PersonFormValues.nameOrderOptions),
		nickname: IndexForms.stringComparisonTranslations,
		alternateNames: IndexForms.stringComparisonTranslations,
		publicNameFormat: IndexForms.getRadioComparisonTranslations(PersonFormValues.publicNameFormatOptions),
		gender: IndexForms.stringComparisonTranslations,
		dateOfBirth: { ...IndexForms.dateComparisonTranslations, ...IndexForms.nullableComparisonTranslations },
		englishLanguageFluency: {
			...IndexForms.getRadioComparisonTranslations(PersonFormValues.englishLanguageFluencyOptions),
			...IndexForms.nullableComparisonTranslations,
		},
		occupation: IndexForms.stringComparisonTranslations,
		nationalIdentificationNumber: IndexForms.stringComparisonTranslations,
		governmentDocumentSeries: IndexForms.stringComparisonTranslations,
		governmentDocumentNumber: IndexForms.stringComparisonTranslations,
		governmentDocumentIssuedBy: IndexForms.stringComparisonTranslations,
		addresses: IndexForms.getMultipleEdgeComparisonTranslations(
			AddressSelectField.Select,
			AddressSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		emailAddresses: IndexForms.getMultipleEdgeComparisonTranslations(
			EmailAddressSelectField.Select,
			EmailAddressSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		employee: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				EmployeeSelectField.Select,
				EmployeeSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		guardian: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				GuardianSelectField.Select,
				GuardianSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		languages: IndexForms.getMultipleEdgeComparisonTranslations(
			LanguageSelectField.Select,
			LanguageSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		nationalities: IndexForms.getMultipleEdgeComparisonTranslations(
			CountrySelectField.Select,
			CountrySelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		phoneNumbers: IndexForms.getMultipleEdgeComparisonTranslations(
			PhoneNumberSelectField.Select,
			PhoneNumberSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		student: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				StudentSelectField.Select,
				StudentSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		taggedMediaAttachments: IndexForms.getMultipleEdgeComparisonTranslations(
			MediaAttachmentSelectField.Select,
			MediaAttachmentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		user: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				UserSelectField.Select,
				UserSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
	},
};

registry.register("Person", advancedFilterInformation, {
	addresses: "Address",
	emailAddresses: "EmailAddress",
	employee: "Employee",
	guardian: "Guardian",
	languages: "Language",
	nationalities: "Country",
	phoneNumbers: "PhoneNumber",
	student: "Student",
	taggedMediaAttachments: "MediaAttachment",
	user: "User",
});
